// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__29I--","inner":"Footer_inner__12TH3"};